<template>
  <div>
    <b-card>
      <div style="position: relative">
        <loading-overlay :loading="councilsLoading" />
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="success"
            @click="onAddClicked"
            v-can="{ slug: $route.meta.slug, action: 'C' }"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            إضافة
          </b-button>
        </div>
        <hr />
        <b-list-group v-if="councils.length > 0">
          <b-list-group-item
            @click.self="
              $router.push({
                name: 'executives-show',
                params: { id: council.id },
              })
            "
            v-for="council in councils"
            :key="council.id"
            class="d-flex justify-content-between align-items-center cursor-pointer"
          >
            <h4>
              مجلس سنة
              {{ council.board_year }} - {{ council.board_end_year }}
            </h4>
            <b-button
              title="حذف"
              v-b-tooltip.hover.v-danger.bottom
              variant="flat-danger"
              class="btn-icon rounded-circle"
              @click="onDelete(council.id)"
              v-can="{ slug: $route.meta.slug, action: 'D' }"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </b-list-group-item>
        </b-list-group>

        <div v-else class="text-muted text-center">لا يوجد أي مجلس بعد</div>

        <form-modal
          ref="councilForm"
          :formSchema="councilForm"
          title="إضافة مجلس"
          v-model="formModal"
          :loading="loading"
          @confirm="onModalConfirmed"
          static
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import dataTable from "@/components/data-table";
import {
  BButton,
  BCard,
  BBadge,
  BDropdown,
  BDropdownItem,
  BListGroup,
  VBTooltip,
  BListGroupItem,
} from "bootstrap-vue";
import FormModal from "@/components/FormModal.vue";
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { getYearsOptions } from "@/utils/utils";

export default {
  components: {
    dataTable,
    BDropdown,
    BDropdownItem,
    BListGroup,
    BListGroupItem,
    BButton,
    BCard,
    BBadge,
    FormModal,
    LoadingOverlay,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  methods: {
    ...mapActions("AdministrativeStatus", [
      "deleteCouncil",
      "addCouncil",
      "fetchCouncils",
    ]),

    onAddClicked() {
      this.$refs.councilForm.init({});
      this.formModal = true;
    },
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المجلس؟", {
          title: "تأكيد حذف المجلس",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteCouncil({ id, type: "executive" })
              .then(() => {
                this.fetchCouncils({ type: "executive" });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تم الحذف بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                  },
                });
              })
              .catch(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "حدث خطأ أثناء حذف المجلس",
                    icon: "XIcon",
                    variant: "danger",
                    timeout: 6000,
                  },
                });
              });
        });
    },

    async onModalConfirmed(form) {
      await this.addCouncil({ type: "executive", form: form })
        .then(() => {
          this.fetchCouncils({ type: "executive" });
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت إضافة المجلس بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 6000,
            },
          });
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء إضافة المجلس",
              icon: "XIcon",
              variant: "danger",
              timeout: 6000,
            },
          });
        });

      this.formModal = false;
    },
  },
  data() {
    return {
      formModal: false,
      councilForm: {
        board_year: {
          component: "FormCleave",
          key: "board_year",
          attrs: {
            label: "سنة المجلس",
            isNumber: true,
            charsCount: 4,
            rules: "required",
          },
        },
        board_end_year: {
          component: "FormCleave",
          key: "board_end_year",
          attrs: {
            label: "سنة انتهاء المجلس",
            isNumber: true,
            charsCount: 4,
            rules: "required",
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters("AdministrativeStatus", [
      "loading",
      "councilsLoading",
      "councils",
    ]),
  },
  created() {
    this.fetchCouncils({ type: "executive" });
  },
};
</script>
